import {PropsWithChildren} from "react";

export interface EmptyListProps extends PropsWithChildren {
  title: string;
  className: string;
  subtitle: string;
}

export const EmptyList = ({title, className, subtitle, children}: EmptyListProps) => (
  <div className={className}>
    <div className="row h-50 mb-3 align-content-center">
      <div className="text-center col-md-10 col-12 offset-md-1 p-1">
        <h3 className="fw-bold">{title}</h3>
        <h5 className="mt-3">{subtitle}</h5>
      </div>
    </div>
    <div className="row">
      <div className="col text-center d-flex flex-column align-items-center">{children}</div>
    </div>
  </div>
);
